import OrderAction from './orderAction';
import { isValidEmail } from './utils';
import Attendee from '../../../models/attendeeModel';
import SendTicketAction from '../../attendee/actions/sendTicketAction';
import Order from '../models/orderModel';

export default class SendReceiptAction extends OrderAction {
    static NAME = 'send_receipt';
    static ASYNCHRONOUS_LIMIT_MIN = 25;

    //for send => not deleted and buyer_email and not invitation
    static condition(order) {
        return (
            ['valid', 'reservation'].includes(order.status) &&
            order.attendee_count > order.attendees_deleted_count &&
            isValidEmail(order.buyer_email) &&
            order.origin_detail !== "Plateforme d'invitations"
        );
    }

    static is_attendee_valid({ attendee, order }) {
        return SendTicketAction.is_attendee_valid({ attendee, order });
    }

    static is_available({ feature_flags }) {
        return !feature_flags.includes('EO_APPR');
    }

    run({ attendees = null, orders = null }) {
        if (attendees) {
            //for send => not deleted only because previous check on the order was already done
            const to_send = attendees.filter(a => !a.removed);
            return Attendee.perform_action(SendTicketAction.NAME, to_send, { organization: this.organization, event: this.event });
        }

        return Order.perform_action(
            this.constructor.NAME,
            orders || this.filtered_items,
            { organization: this.organization, event: this.event },
            this.isAsync(orders || this.filtered_items)
        );
    }
}
